import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class TwfstyleService {

  constructor() { }

  toCssColor(num) {
    num >>>= 0;
    var b = num & 0xFF,
      g = (num & 0xFF00) >>> 8,
      r = (num & 0xFF0000) >>> 16,
      a = ((num & 0xFF000000) >>> 24) / 255;
    return "rgba(" + [r, g, b, a].join(",") + ")";
  }

  toCssColorObj(num) {
    var c: any = new Object();
    num >>>= 0;
    c.b = num & 0xFF,
      c.g = (num & 0xFF00) >>> 8,
      c.r = (num & 0xFF0000) >>> 16,
      c.a = ((num & 0xFF000000) >>> 24) / 255;
  }

  toCssFont(font) {
    if (font == 0)
      return "'Anonymous Pro'";
    if (font == 1)
      return "'Droid Serif'";
    if (font == 2)
      return "'Roboto'";
    else
      return "'Anonymous Pro'"
  }

  toCssFontWeight(bold) {
    if (bold == 1)
      return "bold";
    else
      return "normal";
  }

  toCssFontStyle(italic) {
    if (italic == 1)
      return "italic";
    else
      return "normal";
  }
}
